import DownloadButton from '@/components/DownloadButton';
import Link from 'next/link';

const Page = () => {
  return (
    <>
      <h1>Download</h1>
      <p className="lead">
        Die Inhalte und Komponenten des Styleguides Web FHNW können auf dieser
        Seite heruntergeladen werden.
      </p>

      <p>
        Eine Einführung zur Nutzung des Styleguide bietet die Startseite.
        Konsultieren Sie auch die Seiten{' '}
        <Link
          href={`${process.env.NEXT_PUBLIC_BASE_URL}/corporate-design/webdienste/`}
          legacyBehavior
        >
          <a title="Corporate Design - Webdienste">Webdienste</a>
        </Link>{' '}
        und{' '}
        <Link
          href={`${process.env.NEXT_PUBLIC_BASE_URL}/corporate-design/tools-and-services`}
          legacyBehavior
        >
          <a title="Tools & Services">Tools und Services</a>
        </Link>{' '}
        die beschreiben welche Elemente je nach Anwendungsbereich erforderlich
        sind.
      </p>

      <DownloadButton styles={'btn-primary'} />
    </>
  );
};

export default Page;
